import type { OnInit } from '@angular/core'
import {
  Directive,
  TemplateRef,
  ViewContainerRef,
  inject,
  input,
} from '@angular/core'

import { FeatureFlag } from '../../../environments/environment.interface'
import { FeatureFlagService } from '../../services/feature-flag.service'

@Directive({ selector: '[dhpFeature]' })
export class FeatureFlagDirective implements OnInit {
  private readonly templateRef = inject<TemplateRef<unknown>>(TemplateRef)
  private readonly viewContainer = inject(ViewContainerRef)
  private readonly featureFlagService = inject(FeatureFlagService)

  readonly dhpFeature = input<keyof typeof FeatureFlag>()
  readonly dhpFeatureElse = input<TemplateRef<unknown>>()

  ngOnInit(): void {
    const dhpFeature = this.dhpFeature()
    if (!dhpFeature) {
      return
    }

    const flag = FeatureFlag[dhpFeature]

    if (this.featureFlagService.isEnabled(flag)) {
      this.viewContainer.createEmbeddedView(this.templateRef)
    } else {
      this.viewContainer.clear()

      const dhpFeatureElse = this.dhpFeatureElse()
      if (dhpFeatureElse) {
        this.viewContainer.createEmbeddedView(dhpFeatureElse)
      }
    }
  }
}
